export class FormRangeNumberModel {
    from: number;
    to: number;
}
